export default "__VITE_ASSET__Djwc$4aD__"